// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 291) return "static/chunks/291-9870492cc323fa58.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "0552426446d49cb6" + ".js";
};